import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "asset-hierarchy-view" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between mb-4" }
const _hoisted_3 = { class: "d-flex align-items-center gap-2" }
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = { class: "text-muted small" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center gap-2"
}
const _hoisted_8 = {
  key: 1,
  class: "d-flex align-items-center gap-3 py-4"
}
const _hoisted_9 = {
  key: 2,
  class: "tree-card"
}
const _hoisted_10 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_11 = {
  key: 1,
  class: "tree-list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HierarchyNode = _resolveComponent("HierarchyNode")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("i", { class: "bi bi-diagram-2-fill fs-3 text-primary" }, null, -1)),
        _createElementVNode("div", null, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t('components.assetHierarchy.title')), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('components.assetHierarchy.subtitle')), 1)
        ])
      ]),
      _createElementVNode("button", {
        class: "btn btn-light-primary d-flex align-items-center gap-2",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fetchTree && _ctx.fetchTree(...args))),
        disabled: _ctx.loading
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(["bi bi-arrow-repeat", { 'fa-spin': _ctx.loading }])
        }, null, 2),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetHierarchy.refresh')), 1)
      ], 8, _hoisted_6)
    ]),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.error), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _cache[3] || (_cache[3] = _createElementVNode("span", {
            class: "spinner-border text-primary",
            role: "status"
          }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetHierarchy.loading')), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (!_ctx.tree.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('components.assetHierarchy.empty')), 1))
            : (_openBlock(), _createElementBlock("ul", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tree, (node) => {
                  return (_openBlock(), _createBlock(_component_HierarchyNode, {
                    key: node.id,
                    node: node,
                    "expanded-set": _ctx.expanded,
                    onToggle: _ctx.toggleNode
                  }, null, 8, ["node", "expanded-set", "onToggle"]))
                }), 128))
              ]))
        ]))
  ]))
}